import AddIcon from "../images/add.svg?react";

/**Default: 20px by 20px */
export default function CoreAddIcon({
	height = 20,
	width = 20,
	color = "#42296E",
}: {
	width?: string | number;
	height?: string | number;
	/**@default "#42296E" */
	color?: string;
}) {
	return <AddIcon width={width} height={height} color={color} />;
}
